import type { Game } from '../../game'
import type { SegmentQueryReturnType } from '../components/MarketExplorerSegments/MarketExplorerSegment/MarketExplorerSegment'
import type { Motivation } from '../types/MarketExplorerSegmentData'
import { MarketExplorerSegmentFilterConfig } from '../types/MarketExplorerSegmentFilterConfig'

export const hasMotivationData = (segment: SegmentQueryReturnType) => {
  return (segment.data?.motivationData.motivations?.length || 0) > 0
}

/**
 * Find motivation data for a game.
 * First tries to match by gameId === game.id.
 * Falls back to matching by appId for own games (clones) whose id differs from the motivation data's gameId.
 *
 * Note: The returned entry may have hasBaseValues: false for non-analyzed games.
 * Callers should check hasBaseValues when deciding whether to display motivation values
 * (player archetypes can be shown regardless).
 */
export const findMotivationForGame = (motivations: Motivation[] | undefined, game: Game): Motivation | undefined => {
  return motivations?.find((m) => m.gameId === game.id) || (game.appId > 0 ? motivations?.find((m) => m.appId === game.appId) : undefined)
}

/**
 * Helper method for extracting segment filter min/max values for data requests
 */
export const getRanksDemographicsAndMotivationFilterValues = ({
  filterConfig,
  minValue,
  maxValue,
}: {
  filterConfig: MarketExplorerSegmentFilterConfig<string>
  minValue?: number
  maxValue?: number
}) => {
  const minValueDeviated = minValue !== filterConfig.min
  const maxValueDeviated = maxValue !== filterConfig.max
  let resolvedMinValue, resolvedMaxValue

  if (minValueDeviated && maxValueDeviated) {
    resolvedMinValue = minValue
    resolvedMaxValue = maxValue
  } else if (minValueDeviated) {
    resolvedMinValue = minValue
  } else if (maxValueDeviated) {
    resolvedMinValue = minValue
    resolvedMaxValue = maxValue
  }

  return { minValue: resolvedMinValue, maxValue: resolvedMaxValue }
}
